<template>
  <div class="view pa24">
    <div>
      {{ getOrderStatusText() }}：
      <el-radio
        v-model="radioValue"
        class="mr10"
        style="margin: 0"
        label=""
        border
        size="medium"
        >{{ getAllOrdersText() }}</el-radio
      >
      <el-radio
        v-model="radioValue"
        class="mr10"
        style="margin: 0"
        label="1"
        border
        size="medium"
        >{{ getPendingPaymentText() }}</el-radio
      >
      <el-radio
        v-model="radioValue"
        class="mr10"
        style="margin: 0"
        label="2"
        border
        size="medium"
        >{{ getPendingShipmentText() }}</el-radio
      >
      <el-radio
        v-model="radioValue"
        class="mr10"
        style="margin: 0"
        label="3"
        border
        size="medium"
        >{{ getPendingReceiptText() }}</el-radio
      >
      <el-radio
        v-model="radioValue"
        class="mr10"
        style="margin: 0"
        label="4"
        border
        size="medium"
        >{{ getTransactionCompletedText() }}</el-radio
      >
      <div style="float: left;margin-right: 10px;">
        {{ getOrderNumberText() }}:
        <el-input :placeholder="getOrderNumberPlaceholder()" v-model="ordersNo" style="width:230px;"></el-input>
      </div>
      <el-button type="primary" @click="selectDistributorOrderList"
        >{{ getSearchText() }}</el-button
      >
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          prop="ordersNo"
          align="center"
          :label="getOrderNumberText()"
          width="200px"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" :label="getDistributorNicknameText()">
          <template slot-scope="scope">
            {{ scope.row.name ? scope.row.name : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" :label="getDistributorPhoneText()">
          <template slot-scope="scope">
            {{ scope.row.phone ? scope.row.phone : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" align="center" :label="getGoodsNameText()" />
        <el-table-column prop="allPrice" align="center" :label="getActualPaymentText()">
          <template slot-scope="scope">
            {{
              scope.row.allPrice == 0
                ? 0
                : (scope.row.allPrice / 100).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="royaltyRatio"
          align="center"
          :label="getDistributionCommissionText()"
        >
          <template slot-scope="scope">
            {{
              scope.row.royaltyRatio
                ? scope.row.royaltyRatio .toFixed(2)
                : 0
            }}
          </template>
        </el-table-column>
        <el-table-column prop="level" align="center" :label="getDistributionLevelText()">
          <template slot-scope="scope">
            {{ scope.row.level | level2str }}
          </template>
        </el-table-column>
        <el-table-column prop="payTime" align="center" show-overflow-tooltip :label="getPaymentTimeText()">
          <template slot-scope="scope">
            {{ scope.row.payTime | getDataTimeSec }}
          </template>
        </el-table-column>
        <el-table-column prop="payName" align="center" :label="getPayerNameText()" />
        <el-table-column prop="payPhone" align="center" :label="getContactText()" />
        <el-table-column
          prop="locationAddress"
          align="center"
          show-overflow-tooltip
          :label="getShippingAddressText()"
        />
        <el-table-column align="center" :label="getOrderStatusText()">
          <template slot-scope="scope">
            {{ scope.row.refundState | state2str(scope.row.orderState) }}
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import { selectDistributorOrderList } from "@/api/distribution";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "distributionOrder",
  components: {
    commonTable,
  },
  data() {
    return {
      radioValue: "",
      ordersNo:'',
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      pageSize2: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  filters: {
    level2str(level = 0) {
      let obj = {
        0: "-",
        1: "一级分销",
        2: "二级分销",
        3: "三级分销",
      };
      return obj[level];
    },
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
    state2str(refundState, state) {
      let obj = {
        1: {
          0: "-",
          1: "待付款",
          2: "待发货",
          3: "待收货",
          4: "已完成",
          5: "取消订单",
          6: "退款成功",
        },
        2: "退款中",
        3: "退款成功",
      };

      return refundState == 1 ? obj[refundState][state] : obj[refundState];
    },
  },
  created() {
    this.selectDistributorOrderList();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.selectDistributorOrderList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectDistributorOrderList();
    },
    async selectDistributorOrderList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        orderState: this.radioValue,
        ordersNo:this.ordersNo
      };
      try {
        this.loading = true;
        const result = await selectDistributorOrderList(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.tableData.forEach(item => {
          if(item.royaltyRatio)
            item.royaltyRatio = item.royaltyRatio - 0
          });
        this.total = total;
      } catch (error) {
        this.loading = false;
        this.tableData = [];
        console.log(error);
      }
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getOrderStatusText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '订单状态',
        'zh-TW': '訂單狀態',
        'en': 'Order Status'
      };
      return textMap[currentLanguage] || '订单状态';
    },
    
    getAllOrdersText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '全部订单',
        'zh-TW': '全部訂單',
        'en': 'All Orders'
      };
      return textMap[currentLanguage] || '全部订单';
    },
    
    getPendingPaymentText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '待付款',
        'zh-TW': '待付款',
        'en': 'Pending Payment'
      };
      return textMap[currentLanguage] || '待付款';
    },
    
    getPendingShipmentText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '待发货',
        'zh-TW': '待發貨',
        'en': 'Pending Shipment'
      };
      return textMap[currentLanguage] || '待发货';
    },
    
    getPendingReceiptText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '待收货',
        'zh-TW': '待收貨',
        'en': 'Pending Receipt'
      };
      return textMap[currentLanguage] || '待收货';
    },
    
    getTransactionCompletedText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '交易完成',
        'zh-TW': '交易完成',
        'en': 'Transaction Completed'
      };
      return textMap[currentLanguage] || '交易完成';
    },
    
    getOrderNumberText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '订单编号',
        'zh-TW': '訂單編號',
        'en': 'Order Number'
      };
      return textMap[currentLanguage] || '订单编号';
    },
    
    getOrderNumberPlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入订单编号',
        'zh-TW': '請輸入訂單編號',
        'en': 'Please enter order number'
      };
      return textMap[currentLanguage] || '请输入订单编号';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getDistributorNicknameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销人昵称',
        'zh-TW': '分銷人暱稱',
        'en': 'Distributor Nickname'
      };
      return textMap[currentLanguage] || '分销人昵称';
    },
    
    getDistributorPhoneText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销人手机号',
        'zh-TW': '分銷人手機號',
        'en': 'Distributor Phone'
      };
      return textMap[currentLanguage] || '分销人手机号';
    },
    
    getGoodsNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '商品名称',
        'zh-TW': '商品名稱',
        'en': 'Product Name'
      };
      return textMap[currentLanguage] || '商品名称';
    },
    
    getActualPaymentText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '实付金额（港元）',
        'zh-TW': '實付金額（港元）',
        'en': 'Actual Payment (Yuan)'
      };
      return textMap[currentLanguage] || '实付金额（港元）';
    },
    
    getDistributionCommissionText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销提成（港元）',
        'zh-TW': '分銷提成（港元）',
        'en': 'Distribution Commission (Yuan)'
      };
      return textMap[currentLanguage] || '分销提成（港元）';
    },
    
    getDistributionLevelText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '分销等级',
        'zh-TW': '分銷等級',
        'en': 'Distribution Level'
      };
      return textMap[currentLanguage] || '分销等级';
    },
    
    getPaymentTimeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '付款时间',
        'zh-TW': '付款時間',
        'en': 'Payment Time'
      };
      return textMap[currentLanguage] || '付款时间';
    },
    
    getPayerNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '付款人姓名',
        'zh-TW': '付款人姓名',
        'en': 'Payer Name'
      };
      return textMap[currentLanguage] || '付款人姓名';
    },
    
    getContactText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '联系方式',
        'zh-TW': '聯繫方式',
        'en': 'Contact'
      };
      return textMap[currentLanguage] || '联系方式';
    },
    
    getShippingAddressText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '收货地址',
        'zh-TW': '收貨地址',
        'en': 'Shipping Address'
      };
      return textMap[currentLanguage] || '收货地址';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
